import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: 'glxy-label-hint, [glxyLabelHint]',
  standalone: false,
})
export class LabelHintDirective {
  @HostBinding('class') class = 'glxy-label-hint';

  @Input() align: 'left' | 'right' = 'left';

  @HostBinding('style.text-align')
  get textAlign(): string {
    return this.align;
  }
}
